import { BridgeActionEnum } from "@/types/webview";
import { postWebviewMessage } from "./postWebviewMessage";

export const handleSetLastSeenVersion = (lastSeenAppVersion: string): void => {
  postWebviewMessage({
    action: BridgeActionEnum.SetLastSeenAppVersion,
    lastSeenAppVersion,
  });
};
